import MuiGrid from '../../../UI/MuiGrid/MuiGrid';
import GridOptions from './GridOptions';
import { icons } from '../../../../../shared/icons';

const GridProvider = ({ data, handleOpenDialog, getEditData, isLoading }) => {
  const columns = [
    {
      field: 'id',
      disableExport: true,
      headerName: 'Opcije',
      width: 70,
      sortable: false,
      filterable: false,
      renderCell: (e) => (
        <GridOptions
          handleOpenDialog={() => handleOpenDialog(e.id)}
          getEditData={() => getEditData(e.row)}
        >
          <button className="header-options">{icons.MENU_ICON}</button>
        </GridOptions>
      ),
    },
    { field: 'ime', headerName: 'Ime', width: 200 },
    { field: 'prezime', headerName: 'Prezime', width: 200 },
    { field: 'kontaktTelefon', headerName: 'Kontakt telefon', width: 250 },
    { field: 'email', headerName: 'Email adresa', width: 250 },
  ];

  return (
    <div style={{ height: '85vh', width: '99%' }}>
      <MuiGrid data={data} columns={columns} loading={isLoading} />
    </div>
  );
};

export default GridProvider;
